import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { Icons } from '../../../components';
import css from './Sections.module.css';
import phoneMockupImg from '../../../assets/mobile1.png';

const MobileAppSection = () => {
  return (
    <section className={css.mobileAppSectionMain}>
      <div className={css.container}>
        <div className={css.content}>
          <h2 className={css.title}>
            <FormattedMessage id="LandingPage.mobileAppTitle" />
          </h2>
          <p className={css.description}>
            <FormattedMessage id="LandingPage.mobileAppDescription" />
          </p>

          <div className={css.buttons}>
            <a
              href="https://apps.apple.com/us/app/onbuoy/id6757410812"
              target="_blank"
              rel="noopener noreferrer"
              className={css.appButton}
            >
              <Icons name="appStoreIcon" />
            </a>

            <div className={css.googlePlayWrapper}>
              <span className={css.appButton}>
                <Icons name="googlePlayIcon" />
              </span>
              <span className={css.comingSoon}>Coming Soon</span>
            </div>
          </div>
        </div>

        <div className={css.imageWrapper}>
          <div className={css.phoneMockupContainer}>
            <img src={phoneMockupImg} alt="App Mockup" className={css.phoneImage} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppSection;
